import { useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { InputMoney } from '@/design_system/InputNumber';
import Stack from '@/design_system/Stack';
import IconCheck from '@/icons/Check.svg';
import IconCross from '@/icons/Cross.svg';
import { Currency } from '@/utils/number';

export const EditPrice = ({
  closeEditionMode,
  label,
  currency,
  value,
  setValue,
  savePrice,
  isLoading,
  hasError,
  allowNegativeAmount,
}: {
  closeEditionMode: () => void;
  label: string;
  currency?: Currency | null;
  value?: number;
  setValue: (value?: number) => void;
  savePrice: (value?: number) => Promise<void>;
  isLoading?: boolean;
  hasError?: boolean;
  allowNegativeAmount?: boolean;
}) => {
  const { t } = useLingui();

  if (!currency) {
    return null;
  }

  return (
    <Stack
      row
      gap="0.5rem"
      flexWrap="nowrap"
      alignItems="center"
      justifyContent="flex-end"
      ariaLabel={label}
    >
      <InputMoney
        ariaLabel={t({
          id: 'article.form.actions.price.label',
          message: 'Amount',
        })}
        placeholder="0"
        style={{ maxWidth: '6rem', height: '2rem' }}
        value={value}
        currency={currency}
        onChange={setValue}
        size="small"
        isInvalid={hasError}
        allowNegativeAmount={allowNegativeAmount}
      />
      <Stack row gap="0.25rem" flexWrap="nowrap" alignItems="center">
        <Button
          variant="secondary-danger"
          size="small"
          ariaLabel={t({ id: 'article.form.actions.price.cancel', message: 'Cancel' })}
          tooltip={t({ id: 'article.form.actions.price.cancel', message: 'Cancel' })}
          iconOnly
          onPress={closeEditionMode}
          disabled={isLoading}
        >
          <IconCross />
        </Button>
        <Button
          variant="primary"
          size="small"
          ariaLabel={t({ id: 'article.form.actions.price.save', message: 'Save' })}
          tooltip={t({ id: 'article.form.actions.price.save', message: 'Save' })}
          iconOnly
          onPress={async () => {
            await savePrice(value);
            closeEditionMode();
          }}
          isLoading={isLoading}
        >
          <IconCheck />
        </Button>
      </Stack>
    </Stack>
  );
};
